export default {
  title: 'Ustawienia',
  fields: {
    discount_type: {
      label: 'Typ rabatu',
    },
  },
  buttons: {
    save: 'Zapisz',
    cancel: 'Anuluj',
  },
  toasts: {
    update_successful: 'Zaktualizowano pomyślnie',
    updated_failed: 'Aktualizacja nie powiodła się',
  },
};
